import { getMinMaxTemplateOptions, useVariableByKey } from '@k3/core'
import { Keys } from '../utility/utils'

export const useHighestAndLowestMax = () => {
  const lengthVariable = useVariableByKey(Keys.Length.Variable)
  const widthVariable = useVariableByKey(Keys.Width.Variable)

  const lengthMax =
    lengthVariable != null ? getMinMaxTemplateOptions(lengthVariable).max : 0
  const widthMax =
    widthVariable != null ? getMinMaxTemplateOptions(widthVariable).max : 0

  const highestMax = Math.max(lengthMax, widthMax)
  const lowestMax = Math.min(lengthMax, widthMax)

  return { highestMax, lowestMax }
}
